import { usePusher } from "~/aihd-base-nuxt/composables/usePusher";
import { useUserStore } from "~/store/global/user.store";
export default defineNuxtPlugin(() => {
    const { userData } = storeToRefs(useUserStore());
    const pusherConfig = useRuntimeConfig().public;
    const { initPusher, initSubscription, channel, abortPusher } = usePusher(
        pusherConfig.pusherKey,
        pusherConfig.pusherCluster
    );
    const userId = computed(() => userData?.value?.user_id);
    watch(
        userId,
        () => {
            if (userId.value) {
                if (userId.value && !channel?.value) {
                    initPusher();
                    initSubscription(userId.value);
                }
            } else if (channel.value) {
                abortPusher();
            }
        },
        { immediate: true }
    );
});
